import { useState } from "react";
import { useTran } from "@/hooks";
import { showToast } from "@/lib/utils/toast";
import { authStore } from "@/features/auth/stores";

export const usePasswordForm = () => {
  const { t } = useTran();
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handlePasswordSubmit = async (values, helpers) => {
    const success = await authStore.changePassword(values);
    if (success) {
      helpers.resetForm();
    }
    helpers.setSubmitting(false);
  };

  return {
    toggles: {
      showCurrent,
      showNew,
      showConfirm,
      toggle: (field) => {
        if (field === "current") setShowCurrent((prev) => !prev);
        if (field === "new") setShowNew((prev) => !prev);
        if (field === "confirm") setShowConfirm((prev) => !prev);
      },
    },
    handlePasswordSubmit,
  };
};
